import { css } from 'styled-components';
import elevationCss from './elevation.css';

export const elevationTokens = css`
  ${elevationCss}
`;
